<div class="repayment-report-table-wrapper">
  <table class="repayment-report-table">
    <thead>
      <tr>
        @if (showRepaymentDate) { <th class="repayment-date-column">Repayment date</th> }
        <th class="created-date-column">{{ dateColumnLabel }}</th>
        <th class="metric-column">Data source</th>
        @for (source of dataSources; track source) { <th class="value-column">{{ source }}</th> }
        <th class="total-column">Total</th>
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        @for (_ of [1, 2, 3, 4, 5]; track $index) {
          <tr class="loading-row">
            @if (showRepaymentDate) { <td class="repayment-date-cell"><span class="table-skeleton"></span></td> }
            <td class="created-date-cell"><span class="table-skeleton"></span></td>
            <td class="metric-cell"><span class="table-skeleton"></span><span class="table-skeleton"></span></td>
            @for (source of dataSources; track source) {
              <td class="value-cell"><span class="table-skeleton"></span><span class="table-skeleton"></span></td>
            }
            <td class="total-cell"><span class="table-skeleton"></span><span class="table-skeleton"></span></td>
          </tr>
        }
      } @else {
        @for (group of groups; track group.repaymentDate ?? group.rows[0]?.createdDate; let groupIndex = $index) {
          @for (row of group.rows; track row.createdDate; let rowIndex = $index) {
            <tr [class.striped-row]="groupIndex % 2 === 1">
              @if (showRepaymentDate && rowIndex === 0) {
                <td class="repayment-date-cell" [attr.rowspan]="group.rows.length + 1">{{ formatDate(group.repaymentDate!) }}</td>
              }
              <td class="created-date-cell">{{ showRepaymentDate ? formatDate(row.createdDate) : formatMonth(row.createdDate) }}</td>
              <td class="metric-cell"><span>Payment amount</span><span>Record count</span></td>
              @for (source of dataSources; track source) {
                <td class="value-cell selectable-value-cell" [class.selected-value-cell]="isSelectedCell(group, row, source)">
                  <button type="button" class="aggregate-value-button" [attr.aria-pressed]="isSelectedCell(group, row, source)" [attr.aria-label]="'View contributing repayments for ' + source" (click)="selectCell(group, row, source)">
                    <span>{{ formatMetricAmount(row.values[source]) }}</span><span>{{ formatMetricCount(row.values[source]) }}</span>
                  </button>
                </td>
              }
              <td class="total-cell"><span>{{ formatMetricAmount(rowTotal(row)) }}</span><span>{{ formatMetricCount(rowTotal(row)) }}</span></td>
            </tr>
          }
          @if (showRepaymentDate) {
            <tr class="subtotal-row" [class.striped-row]="groupIndex % 2 === 1">
              <td class="created-date-cell"><strong>Subtotal</strong></td>
              <td class="metric-cell"><span>Payment amount</span><span>Record count</span></td>
              @for (source of dataSources; track source) {
                <td class="value-cell selectable-value-cell" [class.selected-value-cell]="isSelectedSubtotalCell(group, source)">
                  <button type="button" class="aggregate-value-button" [attr.aria-pressed]="isSelectedSubtotalCell(group, source)" [attr.aria-label]="'View contributing repayments for ' + source + ' subtotal'" (click)="selectSubtotalCell(group, source)">
                    <span>{{ formatMetricAmount(sourceTotalForGroup(group, source)) }}</span><span>{{ formatMetricCount(sourceTotalForGroup(group, source)) }}</span>
                  </button>
                </td>
              }
              <td class="total-cell"><span>{{ formatMetricAmount(groupTotal(group)) }}</span><span>{{ formatMetricCount(groupTotal(group)) }}</span></td>
            </tr>
          }
        } @empty {
          <tr><td [attr.colspan]="dataSources.length + (showRepaymentDate ? 4 : 3)" class="empty-row">{{ emptyMessage }}</td></tr>
        }
      }
    </tbody>
    @if (!loading && groups.length) {
      <tfoot>
        <tr>
          @if (showRepaymentDate) { <td></td> }
          <td><strong>Total</strong></td>
          <td class="metric-cell"><span>Payment amount</span><span>Record count</span></td>
          @for (source of dataSources; track source) {
            <td class="value-cell"><span>{{ formatMetricAmount(sourceTotal(source)) }}</span><span>{{ formatMetricCount(sourceTotal(source)) }}</span></td>
          }
          <td class="total-cell"><span>{{ formatMetricAmount(grandTotal()) }}</span><span>{{ formatMetricCount(grandTotal()) }}</span></td>
        </tr>
      </tfoot>
    }
  </table>
</div>
